import React, {useEffect, useState} from 'react';
// import {Configuration, OpenAIApi} from "openai";
import {InputText} from "primereact/inputtext";
import {Badge} from 'primereact/badge';
import GeneralUtils from "../../../utils/GeneralUtils";
import "./ChatGPT.css";

const chatgptIcon = "/icons/chatgpt-icon.svg";
const ChatGPT = () => {
    const [messages, setMessages] = useState([]);
    const [prompt, setPrompt] = useState('');
    const [loading, setLoading] = useState(false);

    const apiKey = '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';
    const me = 'Ben';
    const chatGPT = 'Chat GPT';

    // const configuration = new Configuration({
    //     // organization: process.env.REACT_APP_OPENAI_ORGANIZATION,
    //     // apiKey: process.env.REACT_APP_OPENAI_API_KEY,
    //     organization: "org-HmNKtRF69UDTqGP1tc5NUdzv",
    //     apiKey: "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",
    // });
    //
    // const openai = new OpenAIApi(configuration);

    // const sendMessage = () =>{
    //     setLoading(true);
    //     openai.createCompletion({
    //         model: 'text-davinci-003',
    //         prompt: prompt,
    //         max_tokens: 3000,
    //     }).then(response => {
    //                 const message = {
    //                     id: messages.length + 1,
    //                     sender: 'Ben',
    //                     text: prompt,
    //                     loading: true,
    //                 };
    //                 const newMessage = {
    //                     id: messages.length + 2,
    //                     sender: 'Chat GPT',
    //                     text: response.data.choices[0].text.trim(),
    //                     loading: false,
    //                 };
    //                 setMessages([...messages, message, newMessage]);
    //                 setPrompt('');
    //                 setLoading(false);
    //             });
    // }

    const sendMessage = () => {
        setLoading(true);
        const body = {
            model: 'gpt-3.5-turbo',
            messages: [{"role": "user", "content": prompt}],
            max_tokens: 3000,
            temperature: 0.2
        }

        fetch("https://api.openai.com/v1/chat/completions", {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json', Authorization: `Bearer ${apiKey}`},
            body: JSON.stringify(body)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return result.json();
        }).catch(error => {
            GeneralUtils.notification(error);
        })
            .then(response => {
                const message = {
                    id: messages.length + 1,
                    sender: me,
                    text: prompt,
                    loading: true,
                };
                const newMessage = {
                    id: messages.length + 2,
                    sender: chatGPT,
                    text: response.choices[0].message.content.trim(),
                    loading: false,
                };
                setMessages([...messages, message, newMessage]);
                setPrompt('');
                setLoading(false);
            });
    };

    const handleChage = (e) => {
        setPrompt(e.target.value);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setPrompt(e.target.value)
            sendMessage();
        }
    };

    return (
        <div className="chatgpt-container">
            {messages?.map(message => {
                return <div className={message.sender === me ? "my-question" : "chatgpt-response"}>
                    <div className="messages-container">
                        {message.sender === me ? <Badge value={message.sender} style={{width: "40px"}}/> :
                            <img src={chatgptIcon} style={{width: "40px"}}/>}
                        <p>{message.text}</p>
                    </div>
                </div>
            })}
            <div className="messages-container">
                <span className="p-input-icon-right " style={{width: "100%"}}>
                            {loading ? <i className="pi pi-spin pi-spinner" style={{color: '#708090'}}/>
                                    : <i className="pi pi-send" style={{color: '#708090'}} onClick={sendMessage}/>}
                    <InputText value={prompt} onChange={handleChage} className="inputtext p-inputtext-sm"
                               onKeyDown={handleKeyDown}/>
                </span>
            </div>
        </div>
    )
}

export default ChatGPT;